import { createFileRoute, redirect } from "@tanstack/react-router";
import { getStoredUserRole } from "@/shared/infrastructure/auth/token-storage";
import { AdminSensorParametersPage } from "@/modules/admin/presentation/pages/AdminSensorParametersPage";
import { UserRole } from "@/modules/auth/domain/entities";

export const Route = createFileRoute("/_authenticated/admin-sensor-parameters")({
  beforeLoad: () => {
    if (getStoredUserRole() !== UserRole.Admin) {
      throw redirect({ to: "/" });
    }
  },
  component: AdminSensorParametersPage,
});
